import * as React from 'react';
import * as autoBind from 'react-autobind';
import FullScreenImageContainer from '../FullscreenImage/FullscreenImageContainer';
import ImageZoom from '../../assets/ImageZoom.svg';
import MediaDimensionsModel from '../../types/MediaDimensionsModel';
import ImageCanvas from '../ImageCanvas/ImageCanvas';
import ImageCanvasMediaDimensionsModel from '../../types/ImageCanvasMediaDimensionsModel';
import AnnotationContainer from '../Annotation/AnnotationContainer';
import ReactResizeDetector from 'react-resize-detector';
import EventFactory from '../../utils/EventFactory/EventFactory';
import {AnnotationModes} from '../../globals/Constants';

export default class Image extends React.Component<ImageProps, ImageState> {
   readonly state: ImageState = {showingZoom: false, isImageScaledDown: false};

   constructor(props: ImageProps) {
      super(props);
      autoBind(this);
   }

   setMediaDimensions(dimensions: ImageCanvasMediaDimensionsModel): void {
      this.setState({isImageScaledDown: dimensions.canvas.width < dimensions.image.width || dimensions.canvas.height < dimensions.image.height});
      this.props.setMediaDimensions({
         width: Math.min(dimensions.canvas.width, dimensions.container.width),
         height: Math.min(dimensions.canvas.height, dimensions.container.height)
      });
   }

   onZoom(): void {
      this.setState({showingZoom: true});
   }

   onClose(): void {
      this.setState({showingZoom: false});
   }

   onResize(): void {
      window.dispatchEvent(EventFactory.createEvent('resize'));
   }

   render() {
      const {mediaUrl, allowZoom, allowAnnotation, storeAnnotation, mediaDimensions, annotationMode} = this.props;
      const {showingZoom, isImageScaledDown} = this.state;

      return (
         <div className="image-container">
            <ReactResizeDetector handleWidth handleHeight skipOnMount onResize={this.onResize}/>
            <ImageCanvas mediaUrl={mediaUrl} onDimensionsChange={this.setMediaDimensions}/>
            {allowZoom && isImageScaledDown && annotationMode !== AnnotationModes.edit && <div className="image-container-zoom-button" onClick={this.onZoom}><ImageZoom/></div>}
            {allowZoom && showingZoom && <FullScreenImageContainer onClose={this.onClose}/>}
            {!showingZoom && allowAnnotation && mediaDimensions && <AnnotationContainer center={true} storeAnnotation={storeAnnotation}/>}
         </div>
      );
   }
}

export interface ImageProps {
   mediaUrl: string;
   allowZoom: boolean;
   allowAnnotation: boolean;
   mediaDimensions: MediaDimensionsModel;
   annotationMode?: AnnotationModes;
   storeAnnotation?(annotation: string): void;
   setMediaDimensions(dimensions: MediaDimensionsModel): void;
}

export interface ImageState {
   showingZoom: boolean;
   isImageScaledDown: boolean;
}
